import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createModel, getModels } from './requests';
import { CreatePromptModelRequest, QueryKey } from 'api/model';
import { toast } from 'react-toastify';
import { errorHandler } from 'api/axios_instance';

const queryKey = QueryKey.PromptModels;

const useModels = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const queryClient = useQueryClient();

  const { data: models, isLoading } = useQuery({
    queryKey: [queryKey],
    queryFn: getModels,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });

  const create = useMutation({
    mutationFn: (model: CreatePromptModelRequest) => createModel(model),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [queryKey] });
      toast.success('Prompt model successfully created');
    },
    onError: errorHandler('Creating prompt model failed'),
  });
  return { models, isLoading, create };
};

export { queryKey };
export default useModels;
